"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var RatioTotal = function RatioTotal(_ref) {
  var value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row ratio-row m-b-lg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ratio-value relative"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "absolute"
  }, "="), value)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-xs-10"
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, "TOTAL CREW"))));
};
RatioTotal.propTypes = {
  value: _propTypes["default"].number
};
var _default = exports["default"] = RatioTotal;